// extracted by mini-css-extract-plugin
export var aiStarIcon = "_dl-4";
export var closeButton = "_dl-6";
export var dismissButton = "_dl-3";
export var editImageWithAiContainer = "_dl-8";
export var imageUploadWrapper = "_dl-7";
export var misspelledWord = "_dl-5";
export var spellCheckContainer = "_dl-2";
export var spin = "_dl-1";
export var spinning = "_dl-0";